import React, { SVGProps } from 'react';

const CardVisa: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 64 64'
        width={24}
        height={24}
        {...props}
    >
        <path
            d='M28.252 40.382H24.09l2.593-16.11h4.232l-2.662 16.11zM20.54 24.273L16.58 35.33l-.478-2.39-1.433-7.235s-.137-1.433-1.98-1.433H6.07L6 24.546s2.048.41 4.368 1.843l3.687 13.993h4.368l6.621-16.11H20.54zM53.44 40.382h3.822l-3.345-16.04h-3.344c-1.57 0-1.911 1.228-1.911 1.228L42.45 40.382h4.369l.887-2.389h5.324l.41 2.39zm-4.574-5.734l2.185-6.006 1.228 6.006h-3.413zM42.723 28.164l.614-3.481S41.494 24 39.583 24c-2.048 0-7.03.887-7.03 5.324 0 4.164 5.802 4.232 5.802 6.348 0 2.184-5.188 1.775-6.895.41l-.614 3.617s1.843.888 4.71.888 7.167-1.502 7.167-5.53c0-4.163-5.87-4.572-5.87-6.347.068-1.775 4.095-1.502 5.87-.546z'
            fill='#0066B2'
        />
        <path
            d='M16.102 32.942l-1.433-7.236s-.137-1.433-1.98-1.433H6.07L6 24.546s3.14.683 6.211 3.14c2.936 2.32 3.891 5.256 3.891 5.256z'
            fill='#F9A533'
        />
    </svg>
);

export default CardVisa;
